/**
 * Asignaturas con matriz MINEDUC operativa (OA/OAH/OAA) en backend + UI Studio.
 *
 * Fuentes reales hoy:
 * - matemática / música: matrices en interactive-room/server
 * - lenguaje: docs/Lenguaje OAs.txt → mineducCurriculumLenguaje.js
 *
 * Historia, Ciencias e Inglés: sin archivo OA oficial en el repo → NO entran al allowlist.
 * La UI debe deshabilitar modo curricular con CURRICULUM_COMING_SOON_MESSAGE
 * (no inventar matriz ni dejar caer en "independent" sin aviso).
 */
export const SUBJECTS_WITH_CURRICULUM = new Set(['matematica', 'musica', 'lenguaje']);

/** Asignaturas del catálogo Sala aún sin matriz MINEDUC cargada. */
export const SUBJECTS_PENDING_CURRICULUM = new Set([
  'historia',
  'ciencias',
  'ingles',
  'educacion_fisica',
]);

export const CURRICULUM_COMING_SOON_MESSAGE =
  'Currículo oficial próximamente para esta asignatura';

export function hasCurriculumSubjectSupport(subjectTag: string | null | undefined): boolean {
  return SUBJECTS_WITH_CURRICULUM.has(String(subjectTag || '').trim().toLowerCase());
}

export function isCurriculumPendingSubject(subjectTag: string | null | undefined): boolean {
  return SUBJECTS_PENDING_CURRICULUM.has(String(subjectTag || '').trim().toLowerCase());
}

/** Mensaje UI cuando se intenta modo curricular sin matriz. */
export function curriculumUnavailableMessage(_subjectTag?: string | null): string {
  return CURRICULUM_COMING_SOON_MESSAGE;
}
